import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { useSnackBar } from "../../../hooks/snackBar";
import { saveAs } from "file-saver";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../components/InputSearch";
import {
  listarUsuarioAdmin,
  listarUsuarioAdminComFiltro,
  gerarRelatorioUsuariosAdmin,
} from "../../../services/http/SellerAdminstradorService/usuarioAdminService";

import "./styles.scss";
import ListaAdministradores from "./ListaAdministradores";

const Administradores = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();
  const [busca, setBusca] = useState("");
  const [usuariosAdmin, setUsuariosAdmin] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const carregarListaAdministradores = (pagina) => {
    trackPromise(
      listarUsuarioAdmin(pagina).then((res) => {
        if (res.data) {
          setUsuariosAdmin(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar usuários",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar usuários",
        info: "error",
        open: true,
      });
    });
  };

  const carregarListaUsuarioAdminComFiltro = (filtro, pagina) => {
    trackPromise(
      listarUsuarioAdminComFiltro(filtro, pagina).then((res) => {
        if (res.data) {
          setUsuariosAdmin(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar usuários",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar usuários",
        info: "error",
        open: true,
      });
    });
  };

  const extrairBaseUsuariosAdmin = () => {
    trackPromise(
      gerarRelatorioUsuariosAdmin().then((res) => {
        if (res.data) {
          saveAs(res.data, "usuarios-administradores.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base com usuários",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base com usuários",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaUsuarioSeller = (page) => {
    busca != ""
      ? carregarListaUsuarioAdminComFiltro(busca, page)
      : carregarListaAdministradores(page);
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        carregarListaUsuarioAdminComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      carregarListaAdministradores(1);
    }
  }, [busca]);

  useEffect(() => {
    carregarListaAdministradores(1);
  }, []);

  return (
    <div className="administradores-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Administradores</h2>
        </div>
      </div>

      {/* Botões de ação */}
      <div className="row mb-3">
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="button-anexar buton-green w-100"
            onClick={() => history.push(`/admin/administrador/cadastro`)}
          >
            NOVO ADMINISTRADOR
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={extrairBaseUsuariosAdmin}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>

      {/* Barra de busca */}
      <div className="row mb-3 d-flex justify-content-end">
        <div className="col-sm-6 col-md-3 mb-2">
          <InputSearch buscar={buscar} buscaPor={busca} />
        </div>
      </div>

      {/* Lista de administradores */}
      <div className="row">
        <div className="col-12">
          <ListaAdministradores
            response={usuariosAdmin}
            mudarPagina={mudarPaginaUsuarioSeller}
            buscar={buscar}
            busca={busca}
          />
        </div>
      </div>
    </div>
  );
};

export default Administradores;
